import { aboutPage } from '../../content/about.content';
import { Link } from 'react-router-dom';
import LandingContainer from '../ui/LandingContainer';

const IntractCareers = () => {
	return (
		<LandingContainer className=" pb-14 md:pb-16 lg:pb-0">
			<div className="relative  space-y-16 md:space-y-32">
				<Link
					className=" group relative flex h-full flex-col justify-between gap-6 overflow-hidden rounded-xl py-14 lg:min-h-[525px] "
					to="https://www.linkedin.com/company/intract-io/jobs/"
					target="_blank"
				>
					<div className="relative flex w-full flex-col justify-center gap-10 overflow-hidden rounded-xl bg-black/[89%] px-8 py-[104px] md:flex-row md:gap-16 md:px-40 md:py-[104px] lg:gap-20 lg:px-20 items-center ">
						<Background />
						<div className="flex flex-1 flex-col items-center">
							<div className="docs-card__content md:max-w-[510px]x relative max-w-full">
								<div className="flex w-full flex-col">
									<div className="text-card items-center text-center justify-center md:items-center md:text-center md:justify-center">
										<div className="flex flex-col items-center text-center justify-center md:items-center md:text-center md:justify-center">
											<div className="flex flex-col space-y-4 md:space-y-5 items-center text-center justify-center md:items-center md:text-center md:justify-center">
												<div className="relative">
													<div className="rounded-full border px-3 pb-1.5 pt-[0.5rem] text-center mx-auto w-fit mb-10 font-alliance text-[10px] font-normal uppercase leading-none tracking-[1px] self-center text-white border-white/10 bg-white/5">
														{aboutPage.careers.badge}
													</div>
													<h3 className="w-full transition-colors text-5xl md:max-w-xl text-white">
														{/* {aboutPage.careers.title} */}
														<span className="transition-colors text-violet-400">
															{aboutPage.careers.title}
														</span>
													</h3>
												</div>
												<div
													className="text-md transition-colors text-white-80 w-full"
													style={{ maxWidth: 530 }}
												>
													<p>
														{
															aboutPage.careers
																.description
														}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Link>
			</div>
		</LandingContainer>
	);
};

export default IntractCareers;

const Background = () => {
	return (
		<div className="absolute inset-0 z-10 block h-full w-full overflow-hidden lg:pointer-events-none lg:mx-auto lg:max-w-[1280px]">
			<svg
				className="h-full w-full max-w-[1280px]"
				viewBox="0 0 1280 620"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M-8.08124 -369.719L1283.99 -369.719V-368.175L-8.08124 -368.175V-369.719ZM-40.499 -335.755L-40.499 956.317H-38.9553L-38.9553 -335.755H-40.499ZM82.9962 -244.676L82.9962 -122.724H-8.07758V-121.18H82.9962L82.9962 0.772574H-8.07856V2.31628H82.9962L82.9962 124.269H-8.07953V125.812H82.9962L82.9962 247.764H-8.07953V249.308H82.9962L82.9962 371.259H-8.07758V372.803H82.9962V494.754H-8.07966V496.298H82.9962L82.9962 618.243H-8.08027V619.787H82.9962V741.739H-8.07831V743.282H82.9962L82.9961 865.24H-8.07758V866.784H82.9961V956.317H84.5398V866.784H206.491V956.317H208.035V866.784H329.986V956.317H331.53V866.784H453.482V956.317H455.025V866.784H576.978V956.317H578.521V866.784L700.474 866.784V956.317H702.018V866.784H823.967V956.317H825.511V866.784H947.463V956.317H949.007V866.784H1070.96V956.317H1072.5V866.784H1194.46V956.317H1196V866.784H1284V865.24H1196L1196 743.282H1284V741.739H1196V619.787H1283.99V618.244H1196V496.298H1283.99V494.754H1196V372.803H1284V371.259H1196V249.308H1283.99V247.764H1196V125.813H1283.99V124.269H1196V2.3164H1284V0.772697H1196V-121.18H1284V-122.724H1196V-244.676L1283.99 -244.676V-246.22L1196 -246.22V-335.754H1194.46V-246.22L1072.51 -246.22V-335.754H1070.96V-246.22L949.007 -246.22V-335.754H947.463V-246.22L825.511 -246.22V-335.755H823.967V-246.22L702.018 -246.22V-335.755H700.474V-246.22L578.522 -246.22V-335.754H576.978V-246.22L455.025 -246.22V-335.754H453.482V-246.22L331.53 -246.22V-335.755H329.987V-246.22L208.035 -246.22V-335.755H206.491V-246.22L84.5399 -246.22L84.5399 -335.755H82.9962V-246.22L-8.07953 -246.22V-244.676L82.9962 -244.676ZM206.491 865.24H84.5398L84.5398 743.282H206.491L206.491 865.24ZM329.986 865.24H208.035L208.035 743.282H329.986L329.986 865.24ZM453.482 865.24H331.53L331.53 743.282H453.482L453.482 865.24ZM576.978 865.24H455.025L455.025 743.282H576.978L576.978 865.24ZM700.474 865.24L578.521 865.24L578.522 743.282L700.474 743.282L700.474 865.24ZM823.967 865.24H702.018L702.018 743.282H823.967L823.967 865.24ZM947.463 865.24H825.511L825.511 743.282H947.463L947.463 865.24ZM1070.96 865.24H949.007L949.007 743.282H1070.96V865.24ZM1194.46 865.24H1072.5L1072.51 743.282H1194.46V865.24ZM1194.46 741.739V619.787H1072.51V741.739H1194.46ZM1070.96 741.739V619.787L949.007 619.787V741.739H1070.96ZM947.463 741.739V619.787H825.511V741.739H947.463ZM823.967 741.739V619.787H702.018V741.739H823.967ZM700.474 741.739V619.787H578.522V741.739L700.474 741.739ZM576.978 741.739V619.787H455.025V741.739H576.978ZM453.482 741.739V619.787H331.53V741.739H453.482ZM329.986 741.739V619.787L208.035 619.787V741.739H329.986ZM206.491 741.739V619.787H84.5398V741.739H206.491ZM206.491 618.243H84.5398L84.5398 496.298H206.491L206.491 618.243ZM329.986 618.243L208.035 618.243L208.035 496.298L329.987 496.298L329.986 618.243ZM453.482 618.243H331.53L331.53 496.298H453.482L453.482 618.243ZM576.978 618.243H455.025L455.025 496.298H576.978V618.243ZM700.474 618.243H578.522V496.298H700.474V618.243ZM823.967 618.243H702.018V496.298H823.967V618.243ZM947.463 618.243H825.511V496.298H947.463V618.243ZM1070.96 618.244L949.007 618.243V496.298L1070.96 496.298V618.244ZM1194.46 618.244H1072.51V496.298H1194.46V618.244ZM1194.46 494.754V372.803H1072.51V494.754H1194.46ZM1070.96 494.754V372.803L949.007 372.803V494.754L1070.96 494.754ZM947.463 494.754V372.803H825.511V494.754H947.463ZM823.967 494.754V372.803H702.018V494.754H823.967ZM700.474 494.754V372.803H578.522V494.754H700.474ZM576.978 494.754V372.803H455.025V494.754H576.978ZM453.482 494.754V372.803H331.53V494.754H453.482ZM329.987 494.754V372.803L208.035 372.803V494.754L329.987 494.754ZM206.491 494.754V372.803H84.5398V494.754H206.491ZM206.491 371.259H84.5398L84.5399 249.308H206.491L206.491 371.259ZM329.987 371.259L208.035 371.259L208.035 249.308L329.987 249.308V371.259ZM453.482 371.259H331.53V249.308H453.482V371.259ZM576.978 371.259H455.025V249.308H576.978V371.259ZM700.474 371.259H578.522V249.308H700.474V371.259ZM823.967 371.259H702.018V249.308H823.967V371.259ZM947.463 371.259H825.511V249.308H947.463V371.259ZM1070.96 371.259L949.007 371.259V249.308L1070.96 249.308V371.259ZM1194.46 371.259H1072.51V249.308H1194.46V371.259ZM1194.46 247.764V125.813L1072.51 125.812V247.764H1194.46ZM1070.96 247.764V125.812H949.007V247.764L1070.96 247.764ZM947.463 247.764V125.812H825.511V247.764H947.463ZM823.967 247.764V125.812L702.018 125.812V247.764H823.967ZM700.474 247.764V125.812H578.522V247.764H700.474ZM576.978 247.764V125.812L455.025 125.812V247.764H576.978ZM453.482 247.764V125.812H331.53V247.764H453.482ZM329.987 247.764V125.812H208.035V247.764L329.987 247.764ZM206.491 247.764V125.812L84.5399 125.812L84.5399 247.764H206.491ZM206.491 124.269L84.5399 124.269L84.5399 2.31628L206.491 2.31631L206.491 124.269ZM329.987 124.269H208.035V2.31631H329.987V124.269ZM453.482 124.269H331.53V2.31631H453.482V124.269ZM576.978 124.269L455.025 124.269V2.31631L576.978 2.31634V124.269ZM700.474 124.269H578.522V2.31634H700.474V124.269ZM823.967 124.269L702.018 124.269V2.31634L823.967 2.31637V124.269ZM947.463 124.269H825.511V2.31637H947.463V124.269ZM1070.96 124.269H949.007V2.31637H1070.96V124.269ZM1194.46 124.269L1072.51 124.269V2.31637L1194.46 2.3164V124.269ZM1194.46 0.772697V-121.18L1072.51 -121.18V0.772666L1194.46 0.772697ZM1070.96 0.772666V-121.18L949.007 -121.18V0.772666H1070.96ZM947.463 0.772666V-121.18H825.511V0.772666H947.463ZM823.967 0.772666V-121.18L702.018 -121.18V0.772635L823.967 0.772666ZM700.474 0.772635V-121.18L578.522 -121.18V0.772635H700.474ZM576.978 0.772635V-121.18H455.025V0.772605L576.978 0.772635ZM453.482 0.772605V-121.18L331.53 -121.18V0.772605H453.482ZM329.987 0.772605V-121.18L208.035 -121.18V0.772605H329.987ZM206.491 0.772605V-121.18H84.5399L84.5399 0.772574L206.491 0.772605ZM206.491 -122.724H84.5399L84.5399 -244.676L206.491 -244.676V-122.724ZM329.987 -122.724L208.035 -122.724V-244.676L329.987 -244.676V-122.724ZM453.482 -122.724L331.53 -122.724V-244.676L453.482 -244.676V-122.724ZM576.978 -122.724H455.025V-244.676L576.978 -244.676V-122.724ZM700.474 -122.724L578.522 -122.724V-244.676L700.474 -244.676V-122.724ZM823.967 -122.724L702.018 -122.724V-244.676L823.967 -244.676V-122.724ZM947.463 -122.724H825.511V-244.676L947.463 -244.676V-122.724ZM1070.96 -122.724L949.007 -122.724V-244.676L1070.96 -244.676V-122.724ZM1194.46 -122.724L1072.51 -122.724V-244.676L1194.46 -244.676V-122.724ZM1317.96 -335.754V956.317H1319.5L1319.5 -335.754H1317.96ZM1283.99 988.737L-8.07953 988.737V990.281L1283.99 990.281V988.737Z"
					fill="url(#paint0_radial_4164_49528)"
					fillOpacity="0.1"
				/>
				<path
					d="M1171 713.281V258.781C1171 205.21 1127.57 161.781 1074 161.781V161.781C1020.43 161.781 977 118.353 977 64.7812V2.28125"
					stroke="white"
					strokeOpacity="0.15"
				/>
				<g
					opacity={1}
					transform-origin="1074px 357.7811279296875px"
					style={{
						transform: 'translateY(5.8975%)',
						transformOrigin: '1074px 357.781px',
					}}
				>
					<path
						d="M1171 713.281V258.781C1171 205.21 1127.57 161.781 1074 161.781V161.781C1020.43 161.781 977 118.353 977 64.7812V2.28125"
						stroke="url(#paint1_linear_4164_49528)"
					/>
				</g>
				<path
					d="M1196 0.78125V711.781"
					stroke="white"
					strokeOpacity="0.15"
				/>
				<mask
					id="mask0_4164_49528"
					maskUnits="userSpaceOnUse"
					x={1185}
					y={112}
					width={24}
					height={25}
					style={{ maskType: 'alpha' }}
				>
					<rect
						x={1185}
						y="112.781"
						width={24}
						height={24}
						fill="#D9D9D9"
					/>
				</mask>
				<g mask="url(#mask0_4164_49528)">
					<path
						d="M1195.72 125.131H1190.37V124.431H1195.72V119.081H1196.42V124.431H1201.76V125.131H1196.42V130.481H1195.72V125.131Z"
						fill="#EEEEEE"
						fillOpacity="0.8"
					/>
				</g>
				<path
					d="M110 0.78125V371.402C110 418.346 148.056 456.402 195 456.402V456.402H202C257.228 456.402 302 501.173 302 556.402V1267.78"
					stroke="white"
					strokeOpacity="0.15"
				/>
				<g
					opacity={1}
					transform-origin="206px 634.2806395888329px"
					style={{
						transform: 'translateY(20%)',
						transformOrigin: '206px 634.281px',
					}}
				>
					<path
						d="M110 0.78125V371.402C110 418.346 148.056 456.402 195 456.402V456.402H202C257.228 456.402 302 501.173 302 556.402V1267.78"
						stroke="url(#paint2_linear_4164_49528)"
					/>
				</g>
				<path
					d="M85.5 0.78125V711.781"
					stroke="white"
					strokeOpacity="0.15"
				/>
				<mask
					id="mask1_4164_49528"
					maskUnits="userSpaceOnUse"
					x={73}
					y={359}
					width={24}
					height={25}
					style={{ maskType: 'alpha' }}
				>
					<rect x={73} y="359.781" width={24} height={24} fill="#D9D9D9" />
				</mask>
				<g mask="url(#mask1_4164_49528)">
					<path
						d="M84.5841 372.131H79.2383V371.431H84.5841V366.081H85.2836V371.431H90.6294V372.131H85.2836V377.481H84.5841V372.131Z"
						fill="#EEEEEE"
						fillOpacity="0.8"
					/>
				</g>
				<defs>
					<radialGradient
						id="paint0_radial_4164_49528"
						cx={0}
						cy={0}
						r={1}
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(639.501 310.281) rotate(90) scale(680 680)"
					>
						<stop stopColor="white" />
						<stop offset={1} stopColor="white" stopOpacity={0} />
					</radialGradient>
					<linearGradient
						id="paint1_linear_4164_49528"
						x1="1114.5"
						y1="345.5"
						x2={1116}
						y2={239}
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#ECFC39" stopOpacity={0} />
						<stop offset="0.0864046" stopColor="#ECFC39" />
						<stop offset={1} stopColor="#ECFC39" stopOpacity={0} />
					</linearGradient>
					<linearGradient
						id="paint2_linear_4164_49528"
						x1={206}
						y1="160.5"
						x2={206}
						y2="258.781"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#ECFC39" stopOpacity={0} />
						<stop offset="0.960564" stopColor="#ECFC39" />
						<stop offset={1} stopColor="#ECFC39" stopOpacity={0} />
					</linearGradient>
				</defs>
			</svg>
		</div>
	);
};
